import React from 'react';
import logo from '../images/skyhawks_peninsula_logo.png';
import './Layout.css';
import { isLoggedIn, logout } from '../api/auth';
import { Link } from 'react-router-dom';
import HamburgerMenu from './HamburgerMenu';

const Layout = ({ children }) => {
  const logoutAndReturnToMain = () => {
    logout()
    window.location.reload()
  }
  return (
    <>
      <header className="header">
        <div className="header-left">
          <div className="logo-container">
            <Link to="/"><img src={logo} alt="Logo" className="logo" /></Link>
          </div>
          <HamburgerMenu />
        </div>
        {isLoggedIn() && <nav className="nav">
          <Link className="navItem" to="/changePassword">Change password</Link>
          <div className="navItem" onClick={logoutAndReturnToMain}>Logout</div>
          {/* Add your navigation links here */}
        </nav>}
      </header>
      {children}
    </>
    
  );
};

export default Layout;